<template>

  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex xs12 md12>
        <material-card
            class="card-tabs"
            color="green">
          <v-flex slot="header">
            Results summary
          </v-flex>

          <v-flex row>
            <div  class="date-range col-md-6">
              <label for="picker">Select Dates:</label>
              <date-range-picker
                  id="picker"
                  ref="picker"
                  class="col-md-6"
                  :opens="opens"
                  :singleDatePicker="singleDatePicker"
                  :timePicker="false"
                  :showWeekNumbers="false"
                  :showDropdowns="false"
                  :autoApply="autoApply"
                  v-model="dateRange"

                  :linkedCalendars="linkedCalendars"
                  :dateFormat="dateFormat"
              >
                <template v-slot:input="picker" style="min-width: 350px;">
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </template>
              </date-range-picker>
            </div>
            <div class="col-md-6 ">
              <v-checkbox label="Show Since Start" v-model="showFromStart" ></v-checkbox>
            </div>



          </v-flex>
          <v-flex>
            <div class="small">
              <AreaChart v-if="loaded && currentChart == 'area'" :options="options" :width="400" :height="400" :chart-data="datacollection"></AreaChart>
              <barchart v-if="loaded && currentChart == 'bar'" :options="options" :width="400" :height="400" :chart-data="datacollection"></barchart>
            </div>
            <v-flex>
              <div class="small">
                <LineChart v-if="loaded && currentChartScansOverTime == 'line'" :options="scan_over_time_options" :width="400" :height="400" :chart-data="scans_over_time"></LineChart>
                <barchart v-if="loaded && currentChartScansOverTime == 'bar'" :options="scan_over_time_options" :width="400" :height="400" :chart-data="scans_over_time"></barchart>

              </div>

            </v-flex>

          </v-flex>
        </material-card>
        <v-dialog
            v-model="progressDialog"
            hide-overlay
            persistent
            width="300"
        >
          <v-card
              color="primary"
              dark
          >
            <v-card-text>
              Loading Data
              <v-progress-linear
                  indeterminate
                  color="white"
                  class="mb-0"
              ></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import AreaChart from "../plugins/AreaChart";
import barchart from "../plugins/barchart";
import {getAreaChartData, getFakeVsGenuine, getScansOverTime} from "../api/routes";
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import moment from 'moment'
import LineChart from "../plugins/LineChart";

export default {
  name: "Graphs",
  components: {
    LineChart,
    AreaChart,
    barchart,
    DateRangePicker
  },
  data() {
    return {
      opens: "right",
      minDate: null,
      currentChart: 'bar',
      currentChartScansOverTime: 'line',
      maxDate: null,
      singleDatePicker: null,
      timePicker: null,
      timePicker24Hour: null,
      linkedCalendars: null,
      dateFormat: null,
      showWeekNumbers: null,
      showDropdowns: null,
      autoApply: true,
      dateRange: {
        startDate: moment().startOf('year'),
        endDate: new Date()

      },
      datacollection: null,
      scans_over_time: null,
      showFromStart: false,
      options: null,
      scan_over_time_options: null,
      loaded: false,
      progressDialog: true,
      date: null,
      knowColors: [
        '#696969', '#bcf2f6', '#8EB1C7',
        '#417ac5', '#696966', '#333333',
        '#b6fcd5', '#101010', '#C1BFB5',
        '#dddddd', '#b4eeb4', '#088da5',
        '#0e2f44', '#f08080', '#cccccc',
        '#CE3A0F', '#E1643A', '#C7B0A1',
        '#E0DEDA', '#EFEEED', '#CAA997'
      ],
      fakeColors: [
        '#9B2C33', '#A43F46', '#AC5057',
        '#B46066', '#BB6E74', '#C17B81',
        '#C7878C', '#CC9296'

      ],
      undecidedColors: [
        '#22223b',  '#489ac5',  '#9db4c0',
        '#002766',  '#dcdcdd',  '#a2abaa',
        '#24a0d8',  '#004e98',  '#003459'
      ]
    }
  },
  mounted() {
    this.options = {
      responsive: true,
      maintainAspectRatio: false,
      tooltips: {
        callbacks: {
          label: function (tooltipItem, data) {
            return parseFloat(tooltipItem.value).toFixed(2) + '%';
          }
        }
      },
      legends: {
        display: true,
        position: 'bottom'
      },
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true,
          },
          stacked: true,
        }],
        xAxes: [
          {
            stacked: true,
            type: 'time',
            offset: true,
            time: {
              unit: 'month',
              displayFormats: {
                quarter: 'MMM YYYY'
              }
            },

          }
        ]
      },

    };
    this.scan_over_time_options = {
      responsive: true,
      maintainAspectRatio: false,

      legends: {
        display: true,
        position: 'bottom'
      },
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true,
          },
          stacked: true,
        }],
        xAxes: [
          {
            stacked: true,
            type: 'time',
            offset: true,
            time: {
              unit: 'month',
              displayFormats: {
                quarter: 'MMM YYYY'
              }
            },

          }
        ]
      },

    };

    this.getDashboardData()

  },
  watch: {
    dateRange: 'getDashboardData',
    showFromStart: function (val) {
      if (val){

        this.dateRange = {
          startDate: moment().year(1997).startOf('year'),
          endDate: moment().endOf('year')
        }
      } else{
        this.dateRange = {
          startDate: moment().startOf('year'),
          endDate: moment().endOf('year')

        }
      }
    }
  },
  filters: {
    formatDate: function (date) {
      return moment(date).format("MM-DD-YYYY")
    },
  },
  methods: {


    getRandomColor() {
      var letters = '0123456789ABCDEF';
      var color = '#';
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    getRandomInt () {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5
    },
    getDashboardData(){
      this.progressDialog = true;

      let postData = {
        'startDate' :   moment(this.dateRange.startDate).format('YYYY-MM-DD'),
        'endDate'   :   moment(this.dateRange.endDate).format('YYYY-MM-DD'),
        'selected_id':  localStorage.getItem('open_id')
      };
      getScansOverTime(postData)
          .then(resp => resp.data)
          .then(resp => {
            this.scans_over_time = {
              labels:  resp.labels,
              datasets: [

              ]
            };
            let data = resp.data;
            console.log(data)
            let label = data.label;
            let set = {
              label: label,
              backgroundColor: '#417ac5',
              data: data.count,
            };
            this.scans_over_time.datasets.push(set);
          }).catch(error => {
        console.log('error', error)
      }).finally(final => {
        this.loaded = true;
        this.progressDialog = false;
      })
      getFakeVsGenuine(postData)
          .then(resp => resp.data)
          .then(resp => {
            this.datacollection = {
              labels:  resp.labels,
              datasets: [

              ]
            };
            let data = resp.data;
            let fakeColorIndex = 0;
            let undecidedColorIndex = 0;
            for (let i = 0; i < data.length; i++) {
              let stackNumber = 0;
              let color = '';

              let label = data[i].label;

              if (label === 'GENUINE') {
                stackNumber = 1;
                color = '#02c39a';
              }
              // FAKES
              else if (label === 'FAKE') {
                stackNumber = 2;
                color = this.fakeColors[fakeColorIndex]
                fakeColorIndex  = fakeColorIndex +2;
                if (fakeColorIndex > this.fakeColors.length)
                  fakeColorIndex = 1;
              } else if (label === 'UNDECIDED')
                return;


              if (!label)
                label = 'UNKNOWN';
              let set = {
                label: label,
                backgroundColor: color,
                data: data[i].count,
                stack: stackNumber,
              };
              this.datacollection.datasets.push(set);

            }


          }).catch(error => {
        console.log('error', error)
      }).finally(final => {
        this.loaded = true;
        this.progressDialog = false;
      })
    },

  }
}
</script>
<style>
.small {
  height: 400px;
}
.date-range {
  max-width: 600px;
  height: 40px;
}

</style>
